import { Phone, MessageCircle, ArrowRight } from "lucide-react";

const FinalCTA = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block bg-amber-500/20 backdrop-blur-sm border border-amber-500/30 rounded-full px-6 py-2 mb-8">
            <span className="text-amber-400 font-semibold text-sm tracking-wide">GET STARTED TODAY</span>
          </div>

          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Secure Your Property 
            <span className="block text-transparent bg-gradient-to-r from-amber-400 to-emerald-400 bg-clip-text">
              Legally Today
            </span>
          </h2>
          
          <p className="text-xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
            Don't let legal complexities hold you back. Partner with Bengaluru's most trusted property registration experts with 20+ years of proven excellence.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-6 mb-16">
            <a 
              href="tel:+918217026707"
              className="group bg-gradient-to-r from-emerald-500 to-emerald-600 text-white px-10 py-5 rounded-xl font-bold text-lg hover:from-emerald-600 hover:to-emerald-700 transition-all duration-300 shadow-2xl hover:shadow-emerald-500/50 hover:scale-105 flex items-center gap-3"
            >
              <Phone className="group-hover:rotate-12 transition-transform" size={24} />
              +91 82170 26707
            </a>
            
            <a 
              href="tel:+917411026699"
              className="group bg-white text-slate-800 px-10 py-5 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:scale-105 flex items-center gap-3"
            >
              <Phone className="group-hover:rotate-12 transition-transform" size={24} />
              +91 74110 26699
            </a>

            <a 
              href="https://wa.me/918217026707"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-r from-amber-500 to-amber-600 text-white px-10 py-5 rounded-xl font-bold text-lg hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-2xl hover:shadow-amber-500/50 hover:scale-105 flex items-center gap-3"
            >
              <MessageCircle className="group-hover:scale-110 transition-transform" size={24} />
              Chat on WhatsApp
            </a>
          </div>

          {/* Trust indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-12 border-t border-white/20">
            <div className="text-center">
              <div className="text-4xl font-bold text-amber-400 mb-2">20+</div>
              <div className="text-gray-300 text-sm">Years of Trust</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-emerald-400 mb-2">5000+</div>
              <div className="text-gray-300 text-sm">Happy Clients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-400 mb-2">100%</div>
              <div className="text-gray-300 text-sm">Legal Compliance</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-purple-400 mb-2">24/7</div>
              <div className="text-gray-300 text-sm">Support</div>
            </div>
          </div>

          {/* Email */}
          <div className="mt-12 pt-8 border-t border-white/20">
            <p className="text-gray-300 mb-2">Or email us at</p>
            <a 
              href="mailto:chaitraenterprisesbsk@gmail.com"
              className="text-emerald-400 hover:text-emerald-300 font-semibold text-lg transition-colors"
            >
              chaitraenterprisesbsk@gmail.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
